export default "__VITE_ASSET__pk7eKo1v__";